/**
 * Checks if a token is expired based on its expiration timestamp
 * Uses >= comparison to consider tokens expired at exactly the current moment
 *
 * @param expiresAt - ISO string or timestamp of token expiration
 * @returns true if token is expired, false otherwise
 */
export const isTokenExpired = (
  expiresAt: string | null | undefined,
): boolean => {
  if (!expiresAt) return true;

  const expirationTime = new Date(expiresAt).getTime();
  const now = Date.now();

  return now >= expirationTime;
};

/**
 * Clears all auth-related data from sessionStorage
 */
export const clearAuthStorage = (): void => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('tokenExpiresAt');
  sessionStorage.removeItem('userId');
};
